import React, { SFC } from 'react'
import { Link } from 'react-router-dom'

import { links } from '../../app.links'

import { IS_DEV } from '../../../environment'

import aspireLogo from './aspire-logo-old.svg'

import './activity-bar.scss'

export const ActivityBar: SFC = ({ children }) => {
  return (
    <div className="activity-bar" data-test="sidebar">
      <Link className="activity-bar__navlink activity-bar__logo" to={links.frontFace.home()}>
        {IS_DEV ? ':re' : <img src={aspireLogo} />}
      </Link>
      {children}
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/app/shared/components/activity-bar.tsx